"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryAssignationConfig = void 0;
const class_validator_1 = require("class-validator");
class CountryAssignationConfig {
    _id;
    countryId;
    enableClaiming;
    claimingDefaultFee;
    claimingDefaultMonthlyAmount;
    earlyAssignationBaseDiscount;
    earlyAssignationDiscount;
    tripDurationDiscountMax;
}
exports.CountryAssignationConfig = CountryAssignationConfig;
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CountryAssignationConfig.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CountryAssignationConfig.prototype, "countryId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CountryAssignationConfig.prototype, "enableClaiming", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CountryAssignationConfig.prototype, "claimingDefaultFee", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], CountryAssignationConfig.prototype, "claimingDefaultMonthlyAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CountryAssignationConfig.prototype, "earlyAssignationBaseDiscount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CountryAssignationConfig.prototype, "earlyAssignationDiscount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], CountryAssignationConfig.prototype, "tripDurationDiscountMax", void 0);
//# sourceMappingURL=CountryAssignationConfig.js.map